import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { authApi, formatApiError } from "../lib/api";

export default function ForgotPasswordPage() {
  const [username, setUsername] = useState("");
  const [ok, setOk] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await authApi.forgot(username.trim().toLowerCase());
      setOk(true);
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col"
         style={{ background: "linear-gradient(180deg,#F0F6FC 0%,#ffffff 100%)" }}>
      <header className="px-6 sm:px-10 py-6 flex items-center">
        <img src="/valfrimobil-logo.webp" alt="ValfriMobil" className="h-10 w-auto" />
      </header>
      <main className="flex-1 flex items-start justify-center px-4 pt-10 sm:pt-16">
        <div className="w-full max-w-md bg-white rounded-2xl shadow border border-slate-100 p-8 fade-in-up">
          <h1 className="text-2xl font-bold display-tight mb-2" style={{ fontFamily: "Manrope, sans-serif" }}>
            Glömt PIN-kod?
          </h1>
          <p className="text-slate-500 text-sm mb-6">
            Kontakta administratören för att få en aktiveringslänk. Du kan också registrera din förfrågan här.
          </p>
          {ok ? (
            <div data-testid="forgot-ok" className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg p-3">
              Begäran registrerad. Administratören kommer att skicka en aktiveringslänk till dig.
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="u">Användarnamn</Label>
                <Input id="u" value={username} onChange={(e)=>setUsername(e.target.value)}
                       autoComplete="username" required placeholder="t.ex. radhika"
                       data-testid="forgot-username" />
              </div>
              {err && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-2">{err}</div>}
              <Button type="submit" disabled={busy}
                      className="press-feedback w-full rounded-full py-5 text-white font-semibold min-h-[48px]"
                      style={{ backgroundColor: "#3B9EDA" }}>
                {busy ? "Skickar…" : "Skicka begäran"}
              </Button>
            </form>
          )}
          <p className="mt-6 text-center">
            <Link to="/login" className="text-sm text-[#3B9EDA] hover:underline">Tillbaka till inloggning</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
